module.exports = __webpack_public_path__ + "img/whatsapp.df416195.svg";